import React, { Component } from 'react';
import cx from 'classnames';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';

import styles from './index.module.scss';

interface IProps extends Omit<InputProps, 'status'> {
  error?: boolean;
  containerClassName?: string;
}

export class SxInput extends Component<IProps> {
  render(): JSX.Element {
    const {
      placeholder,
      containerClassName,
      ...remainingProps
    } = this.props;

    const placeholderValue = placeholder ?? 'Write here';

    return (<div className={cx(styles.inputStyle, containerClassName)}>
      <Input
        placeholder={placeholderValue}
        {...remainingProps}
      />
    </div>);
  }
}
